var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltslashfill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 75.9300 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3027-30.8594C10.3027-29.1504 11.6211-27.8809 13.4277-27.8809L34.9609-27.8809L23.6328 2.88086C21.9727 7.32422 26.6113 9.7168 29.541 6.10352L64.4531-37.5C65.1367-38.4277 65.5273-39.2578 65.5273-40.2344C65.5273-41.9434 64.1602-43.2129 62.4023-43.2129L40.8691-43.2129L52.1973-73.9746C53.8574-78.418 49.2188-80.8105 46.2891-77.1973L11.377-33.5938C10.6934-32.666 10.3027-31.8359 10.3027-30.8594Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9375-1.07422C64.1113 2.14844 69.3359 2.14844 72.4609-1.07422C75.6348-4.19922 75.6348-9.42383 72.4609-12.5977L14.9902-70.0195C11.7676-73.2422 6.54297-73.2422 3.41797-70.0195C0.292969-66.8457 0.341797-61.6211 3.41797-58.4961Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3066-4.44336C65.625-3.125 67.7734-3.125 69.043-4.44336C70.3613-5.71289 70.3613-7.86133 69.043-9.17969L11.5723-66.6504C10.3027-67.9688 8.05664-67.9688 6.78711-66.6504C5.51758-65.3809 5.51758-63.1836 6.78711-61.9141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltslashfill);
export default __webpack_public_path__ + "static/media/bolt.slash.fill.95e30f9312db5cd361e72f1611ac3d24.svg";
export { ForwardRef as ReactComponent };